var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-variant-loader"},[_c('b-overlay',{staticClass:"variant-loader",attrs:{"opacity":0.9,"show":_vm.isLoading,"no-wrap":"","no-center":"","spinner-variant":"primary"}}),(_vm.variant)?_c('v-runtime-template',{attrs:{"template":_vm.variant}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }